import i18next from 'i18next';

i18next.addResources('es', 'investmentSelector', {
  investment: 'Inversión',
  usMillions: 'Millones de U$S',
  apply: 'Aplicar'
});
